
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { CustomerInvoiceRefundStatus } from '../../global/models'

@Component
export default class RefundConfirmModal extends Vue {
  message: string | null = null

  subtitle: string | null = null

  title: string | null = null

  show = false

  confirmed = false

  isRefundable = true
  
  open(status: CustomerInvoiceRefundStatus | null) {
    if (!status) {
      return
    }
    switch (status.code) {
      case 'DISBURSEMENT_ALREADY_PAID':
        this.title = 'Refund Unavailable'
        this.subtitle = 'Disbursement already paid out'
        this.message = 'The job linked to this invoice has been completed, and the payment has already been disbursed. Unfortunately, refunds through the AcudocX system are not possible at this stage. Any refund will need to be arranged externally.'
        this.isRefundable = false
        break
      case 'DISBURSEMENT_IN_BATCH':
        this.title = 'Refund Confirmation'
        this.subtitle = 'Disbursement already in batch job'
        this.message = 'The disbursement linked to this invoice has been attached to a batch job, and will be paid out in the near future. If you confirm this refund the disbursement will need to be rectified outside the system.'
        break
      default:
        this.title = 'Refund Confirmation'
        this.message = 'Are you sure you want to refund this invoice? This action cannot be undone.'
        break
    }
    this.show = true
  }

  close() {
    this.title = null
    this.subtitle = null
    this.message = null
    this.confirmed = false
    this.show = false
    this.isRefundable = true
  }

  confirm() {
    this.$emit('confirm')
    this.close()
  }
}
